var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useQuery } from "react-query";
import { setClientBaseUrl, toolkitClient } from "./client";
import { normalizeCTKDuplicate } from "../util";
const createTake = (contentListItems, ctkToken) => {
  if (!contentListItems || contentListItems.length == 0) {
    return null;
  }
  const itemGraphQL = contentListItems.map(
    (item) => `[{contentId: "${item.contentId}" version: ${item.version} type: "${item.type}"}]`
  ).join(",");
  const takeMutationQuery = `mutation {createTake(dynamicContent: [${itemGraphQL}])}`;
  return toolkitClient({
    url: "/api/graphql",
    method: "POST",
    headers: {
      Authorization: `Bearer ${ctkToken}`,
      "Content-Type": "application/graphql"
    },
    data: takeMutationQuery
  });
};
function useCreateTakeQuery(contentListItems, ctkBaseUrl, ctkToken) {
  setClientBaseUrl(ctkBaseUrl);
  return useQuery(
    ["contentList", contentListItems, ctkBaseUrl, ctkToken],
    () => createTake(contentListItems, ctkToken),
    { enabled: contentListItems && contentListItems.length > 0 }
  );
}
function pathInfoQuery(pathId) {
  return `
query {
path(id: ${pathId})
{
    name
    metadata {
      value
      name
    }
    segments {
        id
        components {
            id
            type
            content {
                contentId
                __typename
                ... on QuestionItemContent {
                    objectives {
                        content { 
                            id
                            contentId
                            labeledVersion
                            ... on ObjectiveContent {
                                objective 
                            }
                        }
                    }
                }
                ... on QuestionContent {
                    objectives {
                        content { 
                            id
                            contentId
                            labeledVersion
                            ... on ObjectiveContent {
                                objective 
                            }
                        }
                    }
                }
                ... on CloseReaderContent {
                    objectives {
                        content { 
                            id
                            contentId
                            labeledVersion
                            ... on ObjectiveContent {
                                objective 
                            }
                        }
                    }
                }
            }
            metadata { 
                value
                name
            }
        }
    }
}
}`;
}
function componentTypeQuery(pathId) {
  return `
query {
  path(id: ${pathId}) {
    segments {
      id
      components {
        id
        type
        content {
          ... on QuestionItemContent {
            components {
              type
            } 
          }
        }
      }
    }
  }
}`;
}
function fetchPath(ctkToken, pathId) {
  return toolkitClient({
    url: "/graphql",
    method: "POST",
    headers: {
      Authorization: `Bearer ${ctkToken}`,
      "Content-Type": "application/graphql"
    },
    data: pathInfoQuery(pathId)
  });
}
function fetchSegments(ctkToken, pathId, playerMode) {
  return toolkitClient({
    url: playerMode === "student" ? "/graphql" : "/api/graphql",
    method: "POST",
    headers: {
      Authorization: `Bearer ${ctkToken}`,
      "Content-Type": "application/graphql"
    },
    data: componentTypeQuery(pathId)
  });
}
function useQuestionItemsQuery(ctkToken, pathId) {
  return useQuery(
    ["questionItems", ctkToken],
    () => __async(this, null, function* () {
      const path = yield fetchPath(ctkToken, normalizeCTKDuplicate(pathId));
      if (!path || !(path == null ? void 0 : path.data))
        return [];
      return path.data.path.segments.flatMap((segment) => {
        return segment.components.map((component) => __spreadProps(__spreadValues({}, component.content), {
          questionId: component.id
        }));
      });
    }),
    { enabled: !!ctkToken }
  );
}
function useSegmentsQuery(ctkToken, pathId, playerMode, isLinkedProject, isPretest) {
  return useQuery(
    ["segments", ctkToken],
    () => __async(this, null, function* () {
      var _a, _b;
      const path = yield fetchSegments(
        ctkToken,
        normalizeCTKDuplicate(pathId),
        playerMode
      );
      if (!path)
        return [];
      return (_b = (_a = path == null ? void 0 : path.data) == null ? void 0 : _a.path) == null ? void 0 : _b.segments;
    }),
    { enabled: !!ctkToken && !!pathId && !isLinkedProject && !isPretest }
  );
}
export {
  createTake,
  useCreateTakeQuery,
  useQuestionItemsQuery,
  useSegmentsQuery
};
